export const dateFormat = (date) => {
  if (!date) return '';
  const modifiedDate = new Date(date);
  return (
    modifiedDate.getDate() +
    '.' +
    (modifiedDate.getMonth() + 1) +
    '.' +
    modifiedDate.getFullYear()
  );
};

export const masterTableDateTimeFormat = (dateObject) => {
  if (!dateObject) return '-';
  const formattedDate = dateFormat(dateObject.recModifiedDate);
  if (!formattedDate) return '-';
  return formattedDate + ' ,' + dateObject.time;
};

export const masterTableStartDateTimeFormat = (dateObject) => {
  if (!dateObject) return '-';
  const formattedDate = dateFormat(dateObject.startDate);
  if (!formattedDate) return '-';
  return formattedDate;
};
